import { useEffect } from 'react';
import { Text } from '@fluentui/react-components';

export default function SettingsSecurity() {
  useEffect(() => {
    window.dispatchEvent(new CustomEvent('setPageContext', {
      detail: { title: 'Security' },
    }));
    return () => {
      window.dispatchEvent(new CustomEvent('setPageContext', { detail: null }));
    };
  }, []);

  return (
    <div style={{ padding: '1rem' }}>
      <Text>Configure security settings here.</Text>
    </div>
  );
}
